// @flow
import React from 'react';
import { localize, unescaped } from '@ta/common.i18n';
import classNames from '@ta/common.classnames';
import { Track } from '@ta/common.tracking';
import { escapeHtml } from '@ta/common.text-html';

import DmoLinkPost from './DmoLinkPost';
import DmoVideoCard from './DmoVideoCard';
import DmoTripCard from './DmoTripCard';
import styles from './SponsoredDmoContentModule.less';

type Props = {|
  sponsorshipData: {
    userId: string,
    items: any,
    userProfile: any,
  },
|};

const DmoItemCard = ({ item }) => {
  if (item.type === 'TRIP') {
    return <DmoTripCard trip={item?.object} />;
  }
  if (item.type === 'LINK_POST') {
    return <DmoLinkPost content={item?.object} />;
  }
  if (item.type === 'VIDEO') {
    return <DmoVideoCard content={item} />;
  }
  return null;
};
const dmoItemId = (item: any) => {
  if (item.type === 'TRIP') {
    return item?.object?.id;
  }
  if (item.type === 'LINK_POST') {
    return item?.object?.postId;
  }
  if (item.type === 'VIDEO') {
    return item?.id;
  }
  return -1;
};
const SponsoredDmoContentModule = ({ sponsorshipData }: Props) => {
  const dmoItem = sponsorshipData?.items?.[0];
  const sponsor = sponsorshipData?.userProfile;
  const trackProps = {
    module: 'Scoped_right_rail',
    action: 'Destination_Spotlight_Impression',
    context: `${dmoItem.type}|${sponsor.userId}`,
    value: dmoItemId(dmoItem),
    once: true,
  };
  if (dmoItem) {
    return (
      <Track mount={trackProps}>
        <div className={styles.container}>
          <div className={styles.title}>
            {localize('destination_spotlight_v2') /* Destination spotlight */}
          </div>
          <div className={styles.sponsoredBy}>
            {/* Sponsored by <a href="{0}" class="{1}">{2}</a> */}
            {unescaped(
              localize('sponsored_by_member', {
                '0': sponsor?.route?.url || '',
                '1': classNames(styles.sponsorName, {
                  [styles.verified]: sponsor?.isVerified,
                }),
                '2': escapeHtml(sponsor?.displayName),
              }),
            )}
          </div>
          <DmoItemCard item={dmoItem} />
        </div>
      </Track>
    );
  }
  return null;
};

export default SponsoredDmoContentModule;
